import React from 'react';
import './HerStory.css';
import PuzzleFact from '../PuzzleFact/PuzzleFact';

const HerStory = () => {
  return (
    <section id="her-story" className="her-story-section">
      <div className="her-story-content">
        <h2 className="her-story-title">Her<br/>Story</h2>
        <div className="her-story-divider"></div>
        
        <div className="story-entry story-entry-1">
          <h3 className="story-date"><PuzzleFact factId="ring-date" /></h3>
          <p className="story-text">
            We went to pick up our wedding rings. The sun was bright, air was light. We walked towards the store with our fingers interlocked. It has become a habit since our first date. I remember that silent, slightly rainy night typical of a London winter: we were lying down face to face, looking at each other. He carefully took my hand, palm to palm, locking our fingers together. Little did he know, I was counting stars in his eyes. The eyes were just as sparkly as they are right now. The wedding rings fit aptly on our fingers. He whispered: "Aww, how I want to wear it right now!"
          </p>
        </div>

        <div className="story-entry story-entry-2">
          <h3 className="story-date"><PuzzleFact factId="decoy-proposal-date" /></h3>
          <p className="story-text">
            He was kneeling in front of me, solemnly like a medieval knight. "Shall we get married?" He asked me with a slightly shaky voice, his eyes were full of anxious anticipation. The ring was presented upside down. I could hear his heart drumming. I burst into tearful laughter: "Of course!". He then gently took my <PuzzleFact factId="decoy-left-hand" />, carefully slide the ring onto my finger. It felt like a destined déjà vu. I remember saying "of course" to him with absolutely no hesitation.
          </p>
        </div>

        <div className="story-entry story-entry-3">
          <h3 className="story-date"><PuzzleFact factId="relationship-date" /></h3>
          <p className="story-text">
            I was sitting by my bed, chatting with him for another night. We had been chatting for nearly a month now, from anything philosophically trivial to anything deeply emotional. I have fallen in love with this person I have never met. Words after words, sentences after sentences, I could not believe I found love between the lines. So when he asked me: "Ning, would you like to be my girlfriend?", I cried with "Of course!"
          </p>
          <p className="story-text story-quote">
            "Let me contribute to your happiness, and share the burden of your sorrows." He said. And he has done so ever since.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HerStory;
